import {Box, Paper, Typography} from '@mui/material';
import {StudyContent} from '@cp/model';
import StudyContentRenderer from '../../atoms/MarkdownContentRenderer/MarkdownContentRenderer';

export interface StudyPageSectionContentProps {
  section: StudyContent;
  subjectColor: {border: string};
  isTouchDevice: boolean;
  onTouchStart?: (e: React.TouchEvent) => void;
  onTouchMove?: (e: React.TouchEvent) => void;
  onTouchEnd?: () => void;
}

export default function StudyPageSectionContent({
  section,
  subjectColor,
  isTouchDevice,
  onTouchStart,
  onTouchMove,
  onTouchEnd,
}: StudyPageSectionContentProps) {
  return (
    <Box
      sx={{
        flex: 1,
        minWidth: 0,
        ...(isTouchDevice && {
          touchAction: 'pan-y',
        }),
      }}
      onTouchStart={isTouchDevice ? onTouchStart : undefined}
      onTouchMove={isTouchDevice ? onTouchMove : undefined}
      onTouchEnd={isTouchDevice ? onTouchEnd : undefined}
      data-testid="study-page-section-content"
    >
      <Paper
        sx={{
          p: {xs: 2, md: 3},
          bgcolor: 'white',
          borderRadius: 2,
          boxShadow: 1,
          minHeight: '400px',
        }}
      >
        <Typography
          variant="h5"
          sx={{fontWeight: 600, mb: 2, color: subjectColor.border}}
          data-testid="study-page-section-title"
        >
          {section.title}
        </Typography>
        <StudyContentRenderer content={section.content} />
      </Paper>
    </Box>
  );
}
